import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AuthProvider from './contexts/AuthContext';
import { ProgressProvider } from './contexts/ProgressContext';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <AuthProvider>
    <ProgressProvider>
      <App />
    </ProgressProvider>
  </AuthProvider>
);